import { cart } from '@/theme/Cart';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { QuantitySelector } from '../QuantitySelector/QuantitySelector';
import { CartMain } from './CartMain';

@Component
export class CartItemRow extends ThemeComponent {
    @Prop item!: Shopify.Liquid.LineItem;

    @Ref({ required: false }) quantitySelector!: QuantitySelector;
    @Ref({ required: false }) removeItemButton!: HTMLButtonElement;

    private cartMain: CartMain|null = null;

    init() {

        // Define cart main element
        if (document.querySelector('cart-main') === null) {
            this.$log.warn(`Cart main element missing`);
            return;
        }
        this.cartMain = document.querySelector('cart-main') as CartMain;

        // Listen for item remove clicks
        if (this.removeItemButton) {
            this.$listen(this.removeItemButton, 'click', () => this.handleQuantity(0));
        }

        // Subscribe to quantity change
        if (this.quantitySelector) {
            this.$subscribe(this.quantitySelector.onChange, (quantity) => {
                this.handleQuantity(quantity).catch((e) => {
                    this.$log.error(`Update quantity failed`, { e });
                });
            });
        }
    }

    async handleQuantity(quantity: number) {

        // Ensure cart main exists
        if (this.cartMain === null) {
            this.$log.error(`Cart main element missing`);
            return;
        }

        // Set cart main loading
        this.cartMain.setLoading(true);

        // Find matching cart item
        let matchingItem = null;
        for (const item of cart.items) {
            if (item.variantId === this.item.id) {
                matchingItem = item;
            }
        }
        if (matchingItem === null) {
            this.$log.error(`No matching item found`);
            return;
        }

        // Attemp quantity update
        try {
            if (quantity === 0) {

                // Remove item
                await cart.removeItem(matchingItem);
            } else {

                // Change item
                await cart.changeItem(matchingItem, quantity, null);
            }
        } catch (event: unknown) {
            const { message } = event as Error;
            this.$log.error('Cart item quantity update error', message);
        }

        // Let cart main handle item changes
        void this.cartMain.updateItemsMarkup();

        // Set cart main loading
        this.cartMain.setLoading(false);
    }
}
